export default {
  data: () => ({
    list: '',
  }),
  computed: {
    prepareList() {
      return this.splitLoop(
        this.makeSplitList(
          this.list,
        ),
      );
    },
    flatList() {
      const list = this.prepareList;
      if (Array.isArray(list)) {
        return this.onlyArr(
          list,
        ).filter(Boolean);
      }
      return list;
    },
  },
  methods: {
    makeSplitList(list) {
      const str = String(list);
      if (str.includes(' ')) {
        return str.split(' ');
      }
      if (str.includes('\n')) {
        return str.split('\n');
      }
      if (str.includes(',')) {
        return str.split(',');
      }
      return str;
    },
    splitLoop(item) {
      if (item) {
        if (Array.isArray(item) && item.length >= 1) {
          return item.map((i) => this.splitLoop(
            this.makeSplitList(i),
          ));
        }
        return item;
      }
      return item;
    },
    onlyArr(items = []) {
      return items.reduce(
        (acc, val) => (Array.isArray(val)
          ? acc.concat(
            this.onlyArr(val),
          ) : acc.concat(val)),
        [],
      );
    },
  },
};
